import templateUrl from './content-sequence.html';

export const contentSequenceDirective = () => ({
    restrict: 'AE',

    scope: {
        title: '@',
        list: '<'
    },

    templateUrl,
    
    link: function (scope) {
        // Parent element
        var ol = document.getElementById('slippylist');

        //before reorder (when `move` event encounter)
        ol.addEventListener('slip:beforereorder', function (e) {
            if (/demo-no-reorder/.test(e.target.className)) {
                e.preventDefault();
            }
        }, false);

        //after reorder (when `mouseup` event encounter)
        ol.addEventListener('slip:reorder', function (e) {
            itemReorder(e.detail, scope.list);
            e.target.parentNode.insertBefore(e.target, e.detail.insertBefore);
            return false;
        }, false);

        //prevent `click + hold` event
        ol.addEventListener('slip:beforewait', function (e) {
            e.preventDefault();
        }, false);
        new Slip(ol);

        //change the order of the list
        function itemReorder(position, list) {
            const item = list[position.originalIndex];
            list.splice(position.originalIndex, 1);
            list.splice(position.spliceIndex, 0, item);
        }

        scope.buttonClick = (button) => {
            if(button.action) {
                button.action();
            }
        }
    }
});



// WEBPACK FOOTER //
// ./src/app/common/components/content-sequence/content-sequence.directive.js